/**
 * Valori commerciali che variano per brand automotive.
 *
 * Oggi vivono in un JSON versionato ([brandRules.json](./brandRules.json)): sono
 * accordi commerciali che cambiano di rado e che il backend non espone. La
 * lettura passa da `getBrandRules`, così che il giorno in cui l'offers-explorer
 * restituirà questi campi basti cambiare questa implementazione senza toccare
 * i punti di chiamata.
 *
 * Un brand non mappato NON eredita un rpl inventato: la chiave viene omessa.
 */
import { DEFAULT_OFFER_TYPE } from './constants'
import { slugSegment } from './naming'
import { OfferCustomerType, OfferType } from './types'
import rules from './brandRules.json'

export interface BrandRules {
  rpl?: number
  offerCustomerType: OfferCustomerType
  offerType: OfferType
}

const DEFAULT_RULES: BrandRules = {
  offerCustomerType: 'B2C',
  offerType: DEFAULT_OFFER_TYPE,
}

type RawRules = Record<string, Partial<BrandRules>>

export function getBrandRules(brandCode?: string): BrandRules {
  const key = slugSegment(brandCode)
  const brandRules = key ? (rules as RawRules)[key] : undefined

  return { ...DEFAULT_RULES, ...brandRules }
}
